module.exports = __webpack_public_path__ + "static/pizza18-e00025a1e2051ba0c9ae058b19ae8dd8.webp";